/*
*
* File JS componente GUESTS
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

// import ScrollMagic from 'ScrollMagic';
// import 'debug.addIndicators';
import 'swiper/css/bundle';
import Swiper, { Navigation, Pagination } from 'swiper';

//--------------------------------------------------------------------//

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

// import galleryOverflow from 'components/gallery-overflow/gallery-overflow';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-guests.scss';

//--------------------------------------------------------------------//


// JS SPECIFICO COMPONENTE
//--------------------------------------------------------------------//

// const listenerClickEvents = () => {
//     const element = document.querySelector('.gallery-overflow__content');

//     if (!element) return;

//     element.addEventListener('click', (evt) => {

//         const rect = evt.target.getBoundingClientRect();
//         const x = evt.clientX - rect.left;
//         const y = evt.clientY - rect.top;

//         let elToClick = document.elementsFromPoint(x, y);

//         let clickTarget = elToClick.find((el) => {
//             return el.className == 'gallery-overflow__item-link';
//         });

//         if (clickTarget != undefined)
//         {
//             clickTarget.click();
//         }


//     });
// }

const initSwiper = () => {
    let elSwiperGuests = document.querySelector('.block-guests .swiper-container');

    if(!elSwiperGuests) return;

    Swiper.use([Navigation, Pagination]);

    const args = {
        slidesPerView: 'auto',
        spaceBetween: 10,
        speed: 600,
        centeredSlides: true,
        loop: true,
        autoplay: {
            delay: 5000,
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            notificationClass: 'swiper-notification'
        },
    };
    
    let swiperMag = new Swiper(elSwiperGuests, args);
}

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockGuests = () => {
    // galleryOverflow();
    // listenerClickEvents();
    initSwiper();
}

export default blockGuests;

//--------------------------------------------------------------------//